import { defineMessages } from 'react-intl';

export default defineMessages({
  ledgerHelpCaption: { defaultMessage: 'Connect your Ledger & Enter PIN' },
  ledgerHelpDescription: {
    defaultMessage:
      'Open the Ethereum application and make sure Contract Data and Browser Support are enabled',
  },
});
